import React from 'react';
// import ReactDOM from 'react-dom';
// import DealerEmployeeEdit from './DealerEmployeeEdit';
import ImageResponsive from '../../../contentful/ImageResponsive';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';

import './DealerEmployee.scss';

class DealerEmployee extends React.Component {
  constructor(props) {
    super(props);

    this.printVisibleOnWeb = this.printVisibleOnWeb.bind(this);
    this.printVisibleAsSalesPerson = this.printVisibleAsSalesPerson.bind(this);
  }

  printVisibleOnWeb() {
    if (this.props.employee.visibleOnWeb === true) {
      return (
        <span className="mf-padding-right-10"><i className="fa fa-check text-success " aria-hidden="true"></i> Synlig på web</span>
      );
    }
    return (
      <span className="mf-padding-right-10"><i className="fa fa-times text-danger" aria-hidden="true"></i> Synlig på web</span>
    );
  }

  printVisibleAsSalesPerson() {
    if (this.props.employee.visibleAsSalesperson === true) {
      return (
        <span><i className="fa fa-check text-success" aria-hidden="true"></i> Salgsperson</span>
      );
    }
    return (
      <span><i className="fa fa-times text-danger" aria-hidden="true"></i> Salgsperson</span>
    );
  }

  render() {
    // console.log('employee', this.props.employee);
    const editLink = `/ansatt/${this.props.employee.id}`;

    const makes = this.props.makes;
    const employee = this.props.employee;

    let visibleForMakes = '';
    if (employee.visibleOnWeb && employee.type && employee.type.length > 0) {
      visibleForMakes = 'Synlig for: Alle merker';
      if (employee.makesBlacklist.length > 0) {
        const visibleMakes = [];
        makes.forEach((make) => {
          if (!employee.makesBlacklist.includes(make.id) && make.isInternal) {
            visibleMakes.push(make.name);
          }
        });
        visibleForMakes = String(`Synlig for: ${visibleMakes.join(', ')}`);
      }
    }

    const styles = {};
    if (employee.hideContactInfo) {
      styles.textDecoration = 'line-through';
    }

    return (
      <div className="dealerEmployee mf-margin-bottom-10">
        <div className="row">
          <div className="col-xs-4 col-sm-3">
            {this.props.employee.image &&
              <ImageResponsive
                className="img-circle"
                src={this.props.employee.image.url}
                width={this.props.employee.image.details.image.width}
                height={this.props.employee.image.details.image.height}
                aspect={1}
              />
            }
            {!this.props.employee.image &&
              <img src="https://dummyimage.com/300x300/CCC/fff" className="img-responsive img-circle" />
            }
          </div>
          <div className="col-xs-8 col-sm-9">
            <h4>
              {this.props.employee.name} <PublishStatusDot entry={this.props.employee} /><br/>
              <small>{this.props.employee.position} {this.props.employee.roles && <span>({this.props.employee.roles.join(', ')})</span>}</small>
            </h4>
            <p style={styles}>
              <i className="fa fa-phone" aria-hidden="true"></i> {this.props.employee.phoneOverride || this.props.employee.phone}
            </p>
            <p style={styles}>
              <i className="fa fa-envelope" aria-hidden="true"></i> {this.props.employee.emailOverride || this.props.employee.email}
            </p>
            <p>
              {this.printVisibleOnWeb()} {/* {this.printVisibleAsSalesPerson()}*/}
            </p>
            <p>{visibleForMakes}</p>
            <Link to={editLink} className="btn btn-default">Rediger</Link>
          </div>
          <div className="col-xs-12 text-right">
            {/* <DealerEmployeeEdit employee={employeeData} />*/}
          </div>
        </div>
      </div>
    );
  }
}

export default DealerEmployee;
